export default __webpack_public_path__ + "static/strawberry-pointing-down-d6bfd90ddb7a219359609392c1bcd652.svg";